import { Chip } from "@mui/material";
import { Chip as CustomChip } from "components/Chip/Chip";
import { Icon } from "components/Icon/Icon";
import { IconCollection } from "components/Icon/IconCollection";
import badgeStyle from "./Badges.module.scss";

const getBadge = (label, icon, type) => (
    <Chip
        label={label}
        size="small"
        variant="outlined"
        color={type}
        key={label}
        className={badgeStyle.singleBadge}
        icon={icon ? <Icon icon={icon} /> : undefined}
    />
);

const getInfoChip = (label, icon?: any) => getBadge(label, icon, "info");
const getWarnChip = (label, icon?: any) => getBadge(label, icon, "warning");
const getErrorChip = (label, icon?: any) => getBadge(label, icon, "error");

export const ReadOnlyBadges = ({ data }: any) => {
    return (
        <>
            {data?.is_readonly && getInfoChip("Read-only")}
            {data?.is_bundle_readonly && getInfoChip("Read-only bundle")}
            {data?.is_project_readonly && getInfoChip("Read-only project")}
        </>
    );
};

export const InTrashBadge = ({ deletedAt }: { deletedAt?: string | null }) =>
    deletedAt ? getInfoChip("In trash", IconCollection.deleteOutline) : null;

export const DeprecationBadge = ({ hasDeprecation }: { hasDeprecation: boolean | null }) =>
    hasDeprecation ? getWarnChip("Has deprecation") : null;

export const SyntaxErrorBadge = ({ hasSyntaxError }: { hasSyntaxError: boolean | null }) =>
    hasSyntaxError ? getErrorChip("Syntax error") : null;

export const BundleContentBadge = ({ isBundleContent }: { isBundleContent?: boolean }) =>
    isBundleContent ? getInfoChip("Bundle content") : null;

export const ChangedBundleBadge = ({ isDirty }: { isDirty?: boolean }) =>
    isDirty ? (
        <div className="bundleChipContainer">
            <CustomChip label="Changed" color="success" />
        </div>
    ) : null;

export const PendingTrashBadge = ({
    pendingTrashIdentityId,
}: {
    pendingTrashIdentityId?: string | null;
}) =>
    pendingTrashIdentityId
        ? getInfoChip("Pending move to trash", IconCollection.deleteOutline)
        : null;

export const PendingRestoreBadge = ({
    pendingRestoreIdentityId,
}: {
    pendingRestoreIdentityId?: string | null;
}) => (pendingRestoreIdentityId ? getInfoChip("Pending restore", IconCollection.restore) : null);

export const PendingDeleteBadge = ({
    pendingDeleteIdentityId,
}: {
    pendingDeleteIdentityId?: string | null;
}) =>
    pendingDeleteIdentityId ? getInfoChip("Pending delete", IconCollection.deleteOutline) : null;

export const BootstrapUserBadge = ({ isBootstrapUser }: { isBootstrapUser?: boolean }) =>
    isBootstrapUser ? getInfoChip("Bootstrap user") : null;
